import { useState, FormEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { submitContact } from '../../services/portfolioApi';

export function Contact() {
  const { t } = useTranslation();
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setStatus('loading');
    try {
      await submitContact(form);
      setStatus('success');
      setForm({ name: '', email: '', message: '' });
    } catch {
      setStatus('error');
    }
  };

  return (
    <section id="contact" className="bg-bg-surface py-24 px-6">
      <div className="mx-auto max-w-xl">
        <h2 className="font-mono text-sm text-accent">{`// ${t('contact.title')}`}</h2>

        {status === 'success' ? (
          <p className="mt-8 text-center text-accent">{t('contact.success')}</p>
        ) : (
          <form onSubmit={handleSubmit} className="mt-8 space-y-4">
            <input
              type="text"
              placeholder={t('contact.name')}
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              required
              className="w-full border border-border bg-bg-primary px-4 py-3 text-sm text-text-primary placeholder:text-text-muted focus:border-accent focus:outline-none"
            />
            <input
              type="email"
              placeholder={t('contact.email')}
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              required
              className="w-full border border-border bg-bg-primary px-4 py-3 text-sm text-text-primary placeholder:text-text-muted focus:border-accent focus:outline-none"
            />
            <textarea
              placeholder={t('contact.message')}
              value={form.message}
              onChange={(e) => setForm({ ...form, message: e.target.value })}
              required
              rows={4}
              className="w-full border border-border bg-bg-primary px-4 py-3 text-sm text-text-primary placeholder:text-text-muted focus:border-accent focus:outline-none resize-none"
            />
            <button
              type="submit"
              disabled={status === 'loading'}
              className="w-full border border-accent py-3 font-mono text-sm text-accent transition-colors hover:bg-accent hover:text-bg-primary disabled:opacity-50"
            >
              {status === 'loading' ? '...' : t('contact.send')}
            </button>
            {status === 'error' && (
              <p className="text-center text-sm text-red-400">{t('contact.error')}</p>
            )}
          </form>
        )}
      </div>
    </section>
  );
}
